/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {Pais} from "../localizacion/pais.model";
import {
    ManagerCachingStrategy,
    PropertyMap,
    ReadWrite
} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Uri} from "../../api/uri";
import {Provincia} from "../localizacion/provincia.model";

@BasicEntity({
    name: 'Direcciones',
    endpoint: 'direccion_personas',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    acceptsBulkIriSearch: true,
    type: 'DireccionPersona',
    managerCaching: ManagerCachingStrategy.PrecacheOnStart
})
export class DireccionPersona extends Resource {

    public static readonly TIPOS_DIRECCION = {
        ENVIO: 'Envío',
        FACTURACION: 'Facturación'
    }

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Tipo de Dirección',
        type: PropertyType.Choice(...Object.values(DireccionPersona.TIPOS_DIRECCION))
        // readWrite: ReadWrite.ReadOnly
    })
    private _tipoDireccion: string;

    @BasicProperty({
        name: 'Calle',
        type: PropertyType.String(),
        order: 0
    })
    private _calle: string;

    @BasicProperty({
        name: 'Población',
        type: PropertyType.String(),
        order: 1
    })
    private _poblacion: string;

    @BasicProperty({
        name: 'Provincia',
        type: PropertyType.Uri(Provincia),
        order: 2
    })
    private _demarcacion: string;

    @BasicProperty({
        name: 'Código postal',
        type: PropertyType.String(),
        order: 3
    })
    private _cp: string;

    @BasicProperty({
        name: 'País',
        type: PropertyType.Uri(Pais),
        order: 4
    })
    private _pais: Uri;

    public static readonly PERSONA_MAP: PropertyMap = {
        keyInApi: 'persona',
        type: PropertyType.FutureUri('persona.model.ts'),
        readWrite: ReadWrite.ReadOnly
    };
    @BasicProperty(DireccionPersona.PERSONA_MAP)
    private _uriPersona: Uri;


    @BasicProperty({
        name: 'Persona Id',
        keyInApi: 'persona.id',
        type: PropertyType.Integer()
    })
    private _personaId;

    @BasicProperty({
        name: 'Histórico',
        type: PropertyType.Boolean(),
        readWrite: ReadWrite.ReadOnly,
        nullable: true,
        order: 3
    })
    private _historico: boolean = false;

    public get lectura(): string {
        return `${this._calle}, ${this._cp}, ${this._poblacion}.`;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get tipoDireccion(): string {
        return this._tipoDireccion;
    }

    set tipoDireccion(value: string) {
        this._tipoDireccion = value;
    }

    get calle(): string {
        return this._calle;
    }

    set calle(value: string) {
        this._calle = value;
    }

    get poblacion(): string {
        return this._poblacion;
    }

    set poblacion(value: string) {
        this._poblacion = value;
    }

    get demarcacion(): string {
        return this._demarcacion;
    }

    set demarcacion(value: string) {
        this._demarcacion = value;
    }

    get cp(): string {
        return this._cp;
    }

    set cp(value: string) {
        this._cp = value;
    }

    get pais(): Uri {
        return this._pais;
    }

    set pais(value: Uri) {
        this._pais = value;
    }

    get uriPersona(): Uri {
        return this._uriPersona;
    }

    set uriPersona(value: Uri) {
        this._uriPersona = value;
    }

    get personaId() {
        return this._personaId;
    }

    set personaId(value) {
        this._personaId = value;
    }

    get historico(): boolean {
        return this._historico;
    }

    set historico(value: boolean) {
        this._historico = value;
    }
}
